import React from "react";
import label from "../../labels/postExaminationProcessObjective_en.json";

const ExamReport = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.ExamReport} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default ExamReport;
